import { Modal } from "reactstrap";
import { useState } from "react";
import { DraftCampaignIcon, homeIcon } from "../../../Shared/SVGs/Shared";
import { X } from "react-feather";
import { useNavigate } from "react-router-dom";
import { updateParams } from "../../Product/productActions";
import { useDispatch, useSelector } from "react-redux";
import { updateCampaignState as videoUpdateCampaignState } from "../../Video/VideoActions";
import {
  updateCampaignState,
  updateVideoPageState,
} from "../../Video/VideoActions";

const DraftModal = ({ open, toggle }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const campaign_response = useSelector(
    (state) => state.campaign_states.campaign_response
  );
  const activeStep = useSelector((state) => state.campaign_states.activeStep);
  const style = {
    fontWeight: "700",
  };
  const goToHome = () => {
    navigate("/home");
  };
  const draftCampaign = (state) => {
    navigate("/videos/campaigns");
    // dispatch(
    //   updateParams({
    //     tab: "Campaigns",
    //     transcriptView: false,
    //     is_widget: false,
    //     search: "",
    //     page: 1,
    //     isTrashTab: false,
    //     isFlaggedTab: false,
    //     isFavoriteTab: false,
    //     isCampaignTab: true,
    //     updateParamsOnly: true,
    //   })
    // );
    // dispatch(
    //   updateVideoPageState({
    //     isCategoryPage: false,
    //     isCampaignListPage: true,
    //   })
    // );
    dispatch(
      videoUpdateCampaignState({
        tab: `${activeStep === 5 ? "ACTIVE" : "DRAFT"}`,
      })
    );
  };

  return (
    <>
      {open && <div className="backdrop"></div>}
      <Modal
        backdropClassName="back-drop"
        isOpen={open}
        toggle={toggle}
        contentClassName="custom-modals-image"
        backdrop={false}
      >
        <div className="cross">
          <div onClick={toggle}>
            {/* {activeStep === 5 && (
              <X size={30} color="black" strokeWidth="2px" />
            )} */}
          </div>
        </div>
        <div
          className={`d-flex justify-content-center ${
            activeStep === 5 ? "" : "mt-5"
          } ${activeStep === 5 ? "mb-1" : "mb-4"}`}
        >
          {DraftCampaignIcon}
        </div>

        <div className="d-flex justify-content-center">
          <div className="modal-text">
            {activeStep !== 5 ? (
              <span>
                Your <span style={style}>"{campaign_response?.name}"</span>{" "}
                campaign has been saved to the Drafts tab in the Campaign folder
              </span>
            ) : (
              <span>
                {" "}
                Your campaign has been saved in the Campaigns folder! Click on{" "}
                <span
                  style={{ color: "#783AD0" }}
                  role="button"
                  onClick={draftCampaign}
                >
                  Active Campaigns{" "}
                </span>
                to see the{" "}
                <span style={style}>"{campaign_response?.name}"</span> campaign
              </span>
            )}
          </div>
        </div>
        {activeStep !== 5 && (
          <div
            className="d-flex justify-content-center align-item-center mb-5"
            onClick={draftCampaign}
          >
            <div className="text-home" role="button">
              <span style={{ color: "black" }}>Go to</span> Drafts
            </div>
          </div>
        )}
        {activeStep === 5 && (
          <div
            className="d-flex justify-content-center align-item-center mb-5"
            onClick={goToHome}
          >
            <div>{homeIcon}</div>
            <div className="text-home" role="button">
              Return to Home
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default DraftModal;
